import { faAngleDown } from '@fortawesome/free-solid-svg-icons'

import Icon from './common-parts/Icon'

export default function DownIcon(props) {
  return (
      <Icon
        size="3x"
        transform="down-3"
        {...props}
        icon={faAngleDown}
      />
  );
}
